import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';

export function useSelectedAlbum(userId: string) {
  const [selectedAlbumId, setSelectedAlbumId] = useState<string | null>(null);

  useEffect(() => {
    async function loadUserMusicPreference() {
      const { data: profile } = await supabase
        .from('profiles')
        .select('onboarding_music_album_id')
        .eq('id', userId)
        .single();

      if (profile?.onboarding_music_album_id) {
        setSelectedAlbumId(profile.onboarding_music_album_id);
      }
    }

    loadUserMusicPreference();
  }, [userId]);

  const handleAlbumSelect = useCallback(
    async (albumId: string) => {
      setSelectedAlbumId(albumId);

      await supabase
        .from('profiles')
        .update({ onboarding_music_album_id: albumId })
        .eq('id', userId);
    },
    [userId]
  );

  return { selectedAlbumId, setSelectedAlbumId, handleAlbumSelect };
}
